import { render } from "./TextusForm.vue?vue&type=template&id=649bfba8&scoped=true"
import script from "./TextusForm.js?vue&type=script&lang=js&external"
export * from "./TextusForm.js?vue&type=script&lang=js&external"

import "./TextusForm.vue?vue&type=style&index=0&id=649bfba8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649bfba8"],['__file',"src/components/ChatWidget/TextusForm/TextusForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "649bfba8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('649bfba8', __exports__)) {
    api.reload('649bfba8', __exports__)
  }
  
  module.hot.accept("./TextusForm.vue?vue&type=template&id=649bfba8&scoped=true", () => {
    api.rerender('649bfba8', render)
  })

}


export default __exports__